var _path, _path2, _rect, _rect2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignLeadExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1878 5.34933C13.8438 5.34933 13.3881 5.34171 12.8208 5.34171C11.4372 5.34171 10.2995 4.19657 10.2995 2.8V0.349714C10.2995 0.156952 10.1457 0 9.95478 0H5.92479C4.04406 0 2.52393 1.54362 2.52393 3.43543V11.645C2.52393 13.6297 4.11647 15.2381 6.0817 15.2381H12.083C13.9569 15.2381 15.4763 13.7044 15.4763 11.811V5.69219C15.4763 5.49867 15.3232 5.34248 15.1315 5.34324C14.8094 5.34552 14.4231 5.34933 14.1878 5.34933Z",
    fill: "#8987E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1119 0.432282C11.8841 0.195329 11.4864 0.358377 11.4864 0.686758V2.6959C11.4864 3.53857 12.1804 4.2319 13.0231 4.2319C13.5542 4.238 14.2917 4.23952 14.918 4.238C15.2387 4.23723 15.4018 3.854 15.1793 3.62238C14.3755 2.78657 12.9363 1.28866 12.1119 0.432282Z",
    fill: "#8987E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.35742,
    width: 10.1429,
    height: 10.1429,
    rx: 5.07143,
    fill: "#8987E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.35742,
    width: 10.1429,
    height: 10.1429,
    rx: 5.07143,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57143 11.8576C6.39985 11.8576 7.07143 11.186 7.07143 10.3576C7.07143 9.52913 6.39985 8.85756 5.57143 8.85756C4.743 8.85756 4.07143 9.52913 4.07143 10.3576C4.07143 11.186 4.743 11.8576 5.57143 11.8576Z",
    stroke: "#DFDFFF",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29773 13.4911C3.52825 13.0921 3.85972 12.7608 4.25883 12.5305C4.65794 12.3001 5.11064 12.1788 5.57145 12.1789C6.03226 12.1789 6.48496 12.3001 6.88407 12.5305C7.28317 12.7608 7.61463 13.0922 7.84515 13.4912",
    stroke: "#DFDFFF",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignLeadExpert);
export default __webpack_public_path__ + "static/media/assignLeadExpert.66092a47f7102f64af2d0e73a8343be2.svg";
export { ForwardRef as ReactComponent };